import React, {useState} from "react"
import {Radio} from "antd"
import {LoginOption} from "../../../models/login-option"
import {ClientKey} from "../../../config/app-config"
import {themeByClientKey} from "../../../theme/theme"
import {loginWithADFS} from "./login-with-adfs"
import {useFeatureToggle} from "../../main/components/FeatureToggleProvider"

export type Credential = { username: string, password: string };
type Props = {
  clientKey: ClientKey
  clientName?: string
  onLogin: (credential: Credential, rememberMe: boolean) => void
  loginPageTitle: {
    title: string
  }
  onForgetPassword: () => void
  loginOption: LoginOption
  setLoginOption: (option: LoginOption) => void
  loginOptions: LoginOption[]
  forGetPassword: boolean
}
export const LoginForm: React.FC<Props> = ({
  clientKey,
  clientName,
  onLogin,
  loginPageTitle,
  onForgetPassword,
  loginOption,
  setLoginOption,
  loginOptions,
  forGetPassword,
}): React.ReactElement => {
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const [credential, setCredential] = useState({username: "", password: ""})
  const [rememberMe, setRememberMe] = useState<boolean>(true)
  const { adfsLogin } = useFeatureToggle()

  const { buttonClass: buttonClassName, systemSubtitle, titleClassName } = themeByClientKey(clientKey)

  function handleKeyPress(event: any) {
    if (event.key === "Enter") {
      onLogin(credential, rememberMe)
    }
  }

  return <>
    <div className="form-layout">
      <div className="form">
        <div className="detail">
          <p className={ titleClassName } style={{textAlign: "center"}}>{ loginPageTitle.title }</p>
          <p className="header" style={{textAlign: "center"}}>{ systemSubtitle }</p>
        </div>
        <div style={{fontWeight: 500, fontSize: "18px"}} className="mb-3">
          <label htmlFor="txtUsername">Username
            <input
              type="email"
              className="input"
              value={credential.username}
              onChange={(evt) => setCredential({...credential, username: evt.target.value})}
              id="txtUsername"
              placeholder="Username"

            />
          </label>

        </div>

        <div style={{fontWeight: 500, fontSize: "18px"}} className="mb-4">
          <label htmlFor="txtPassword" className="form-label"
          >Password
            <input
              id="txtPassword"
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={credential.password}
              className="input"
              onChange={(evt) => setCredential({...credential, password: evt.target.value})}
              onKeyPress={handleKeyPress}
            />
          </label>

          <div
            id='btnEye'
            aria-label="label"
            className={showPassword ? "eye" : "eyeslash"}
            onClick={() => setShowPassword(!showPassword)}
            onKeyPress={() => setShowPassword(!showPassword)}
          />
        </div>

        <div hidden>
          Login mode
          <Radio.Group onChange={evt => setLoginOption(evt.target.value)} value={loginOption} style={{marginLeft: "1rem"}}>
            {
              loginOptions
                .map(loginOption => (<Radio key={loginOption} value={loginOption}>{ loginOption.toUpperCase() }</Radio>))
            }
          </Radio.Group>
        </div>

        <div>
          <input id="chkRemember" type="checkbox" hidden checked={rememberMe} onChange={() => setRememberMe(!rememberMe)}/>
          <label htmlFor="chkRemember" hidden> Remember me</label>
        </div>

        <div className="mb-5">
          <button type="button" onClick={() => onLogin(credential, rememberMe)} className={ buttonClassName }>SIGN IN{ clientName && ` (${clientName})` }</button>
          {/* <button hidden={loginOptions.length === 1 && loginOptions[0] === LoginOption.Local || loginOption !== LoginOption.Local} type="button" onClick={onForgetPassword} className={ buttonClassName }>Forget Password</button> */}
          { loginOptions.length === 1 && loginOptions[0] === LoginOption.Local
            ? <button
              type="button"
              onClick={loginWithADFS}
              className={ buttonClassName }>
              Login with ADFS
            </button>
            : <></>
          }
        </div>
        <br/>
        <br/>
      </div>
    </div>
  </>
}